import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  Card,
  Image,
  Spinner,
} from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import "../../../assets/css/admin/blogInAdmin/blogInAdmin.css";
import AdminMasterLayout from "../../../layout/admin/AdminMasterLayout";

import { FaEdit, FaTrash, FaMagic } from "react-icons/fa"; // ✅ CHANGED: FaMagic added
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

const BlogAdmin = () => {
  // ================= STATES =================

  const [showForm, setShowForm] = useState(false);
  const { baseUrl, baseUrlForFiles, regTpChecker } = useContext(AppContext);
  const [title, setTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [oldImage, setOldImage] = useState("");
  const [btnLabel, setBtnLabel] = useState("Save");
  const [idToUpdateDeleteblog, setIdToUpdateDeleteblog] = useState("");
  const [slug, setSlug] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [keywords, setKeywords] = useState("");
  const [categories, setCategories] = useState([]);
  const [date, setDate] = useState("");
  const [image, setImage] = useState(null);
  const [blogs, setblogs] = useState([]);
  const [addUploadLoading, setAddUploadLoading] = useState(false);
  const [loadingEditId, setLoadingEditId] = useState(null);
  const [loadingDeleteId, setLoadingDeleteId] = useState(null);
  const [aiGenerating, setAiGenerating] = useState(false);

  const publishblog = () => {
    console.log(title, slug, category, description, keywords, date, image);
    const formData = new FormData();
    formData.append("title", title);
    formData.append("slug", slug);
    formData.append("category", category);
    formData.append("description", description);
    formData.append("keywords", keywords);
    formData.append("date", date);
    formData.append("image", image);

    axios
      .post(`${baseUrl}/admin/blog/addblog`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          setAddUploadLoading(false);
          resetForm();
          viewAllUploadedBlog();
          Swal.fire({
            icon: "success",
            title: "Congrats",
            text: "Blog created and publised successfully",
            confirmButtonText: "Cool",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setAddUploadLoading(false);
      });
  };

  // ✅ NEW FUNCTION: AI Generate
  const generateBlogWithAI = () => {
    if (!title.trim()) {
      setErrorMessage("Pehle blog title likhein, phir AI Generate dabayein.");
      return;
    }

    setAiGenerating(true);
    setErrorMessage("");

    axios
      .post(`${baseUrl}/admin/blog/aiGenerateBlog`, { title })
      .then((response) => {
        if (response.data.success) {
          const {
            description: aiDescription,
            keywords: aiKeywords,
            category: aiCategory,
          } = response.data.data;

          if (aiDescription) setDescription(aiDescription);
          if (aiKeywords) setKeywords(aiKeywords);
          if (aiCategory) setCategory(aiCategory);

          Swal.fire({
            icon: "success",
            title: "AI Generated!",
            text: "Blog content successfully generate ho gaya. Review kar ke Publish karein.",
            confirmButtonText: "Theek hai",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: response.data.message || "AI generate nahi ho saka.",
          });
        }
        setAiGenerating(false);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "AI generate karte waqt error aaya. Dobara try karein.",
        });
        setAiGenerating(false);
      });
  };
  // ---------------- FETCH CATEGORIES ----------------
  const viewAllUploadedCategories = () => {
    axios
      .get(`${baseUrl}/admin/tpcategory/viewAllUploadedCategories`)
      .then((response) => {
        console.log("CATEGORIES FROM API:", response.data);

        if (response.data.success) {
          setCategories(response.data.categoryRecords || []);
        } else {
          setCategories([]);
        }
      })
      .catch((error) => {
        console.log("CATEGORY ERROR:", error);
        setCategories([]);
      });
  };

  // ---------------- FETCH Blog ----------------
  const viewAllUploadedBlog = () => {
    axios
      .get(`${baseUrl}/admin/blog/viewAllUploadedBlog`)
      .then((response) => setblogs(response.data.blog))
      .catch((error) => console.log(error));
  };
  const updateBlog = () => {
    const formData = new FormData();
    formData.append("id", idToUpdateDeleteblog);
    formData.append("title", title);
    formData.append("slug", slug);
    formData.append("category", category);
    formData.append("description", description);
    formData.append("keywords", keywords);
    formData.append("date", date);
    if (image) {
      formData.append("image", image);
    }

    axios
      .post(`${baseUrl}/admin/blog/updateBlog`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => {
        viewAllUploadedBlog();
        resetForm();
        setAddUploadLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setAddUploadLoading(false);
      });
  };
  const deleteBlog = (idToDelete) => {
    const formData = new FormData();
    formData.append("id", idToDelete);
    axios
      .post(`${baseUrl}/admin/blog/deleteBlog`, formData)
      .then(() => {
        viewAllUploadedBlog();
        setAddUploadLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setAddUploadLoading(false);
      });
  };

  //  — AI Description Generator
  const generateDescriptionWithAI = () => {
    if (!title.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Title required",
        text: "Pehle blog title likho, phir AI se description generate karo.",
      });
      return;
    }

    setAiGenerating(true);

    axios
      .post(`${baseUrl}/admin/blog/generateDescription`, {
        title,
        category,
        keywords,
      })
      .then((response) => {
        if (response.data.success) {
          setDescription(response.data.description);
          setErrorMessage(
            regTpChecker("blogDescription", response.data.description),
          );
        }
        setAiGenerating(false);
      })
      .catch((err) => {
        console.log(err);
        setAiGenerating(false);
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: "AI description generate nahi ho saki, dobara try karein.",
        });
      });
  };
  // ---------------- RESET FORM ----------------
  const resetForm = () => {
    setTitle("");
    setSlug("");
    setCategory("");
    setDescription("");
    setKeywords("");
    setDate("");
    setImage(null);
    setOldImage("");

    setBtnLabel("Save");

    // agar update/delete id state hai
    setIdToUpdateDeleteblog("");

    // form close karna ho to
    // setShowForm(false);
  };
  useEffect(() => {
    viewAllUploadedBlog();
    viewAllUploadedCategories();
  }, []);

  return (
    <AdminMasterLayout>
      <Container fluid className="p-3 p-md-4">
        {/* ================= HEADER ================= */}

        <Row className="align-items-center mb-3">
          <Col xs={12} md={6}>
            <h4>Blogs Management</h4>
          </Col>

          <Col xs={12} md={6} className="text-md-end mt-2 mt-md-0">
            <Button variant="primary" onClick={() => setShowForm(!showForm)}>
              {showForm ? "Close Form" : " + Add Blog"}
            </Button>
          </Col>
        </Row>
        {/* Error Message */}
        {errorMessage && (
          <div className="buyer-error-message">{errorMessage}</div>
        )}

        {/* ================= CREATE BLOG FORM ================= */}

        {showForm && (
          <Card className="mb-4 shadow-sm border-0">
            <Card.Body>
              <h4>{btnLabel === "Save" ? "Create New Blog" : "Update Blog"}</h4>

              <Form>
                <Row>
                  {/* TITLE */}
                  <Col xs={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Title</Form.Label>

                      <Form.Control
                        type="text"
                        placeholder="Blog title"
                        value={title}
                        onChange={(e) => {
                          {
                            const value = e.target.value;
                            setErrorMessage(
                              regTpChecker("blogTitle", e.target.value),
                            );

                            setTitle(value);

                            // Auto slug generate
                            setSlug(
                              value
                                .toLowerCase()
                                .trim()
                                .replace(/\s+/g, "-") // spaces => -
                                .replace(/[^\w-]+/g, ""), // special chars remove
                            );
                          }
                        }}
                      />
                    </Form.Group>
                  </Col>
                  {/* SLUG */}
                  <Col xs={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Slug</Form.Label>

                      <Form.Control
                        type="text"
                        placeholder="Blog slug"
                        value={slug}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  {/* DESCRIPTION */}2
                  <Col xs={12}>
                    <Form.Group className="mb-3">
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 blog-desc-header">
                        <Form.Label className="mb-0">Description</Form.Label>

                        {/* <Button
                          size="sm"
                          variant="outline-success"
                          disabled={aiGenerating}
                          onClick={generateDescriptionWithAI}
                          className="ai-generate-btn"
                        >
                          {aiGenerating ? (
                            <>
                              <Spinner
                                animation="border"
                                size="sm"
                                className="me-1"
                              />
                              Generating...
                            </>
                          ) : (
                            "✨ Generate with AI"
                          )}
                        </Button> */}
                      </div>

                      <ReactQuill
                        theme="snow"
                        value={description}
                        onChange={(value) => {
                          setDescription(value);
                          setErrorMessage(
                            regTpChecker("blogDescription", value),
                          );
                        }}
                        placeholder="Write blog content..."
                        style={{ height: "250px", marginBottom: "50px" }}
                      />
                    </Form.Group>
                  </Col>
                  {/* IMAGE */}
                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Featured Image</Form.Label>

                      <div className="d-flex align-items-center border rounded p-2">
                        {/* Hidden File Input */}
                        <input
                          type="file"
                          id="blogImage"
                          hidden
                          onChange={(e) => {
                            setImage(e.target.files[0]);
                            setErrorMessage(
                              regTpChecker("blogImage", e.target.files[0]),
                            );
                          }}
                        />

                        {/* Custom Browse Button */}
                        <label
                          htmlFor="blogImage"
                          className="btn btn-light border mb-0"
                        >
                          Browse...
                        </label>

                        {/* Path Show */}
                        <span className="ms-3 text-muted small">
                          {image
                            ? image.name
                            : oldImage
                              ? oldImage
                              : "Choose file"}
                        </span>
                      </div>
                    </Form.Group>
                  </Col>
                  {/* KEYWORDS */}
                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Keywords</Form.Label>

                      <Form.Control
                        type="text"
                        placeholder="comma separated keywords"
                        value={keywords}
                        onChange={(e) => {
                          setKeywords(e.target.value);
                          setErrorMessage(
                            regTpChecker("blogKeyword", e.target.value),
                          );
                        }}
                      />
                    </Form.Group>
                  </Col>
                  {/* CATEGORY */}
                  {/* CATEGORY */}
                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Category</Form.Label>

                      <Form.Select
                        value={category}
                        onChange={(e) => {
                          setCategory(e.target.value);

                          setErrorMessage(
                            regTpChecker("blogCategory", e.target.value),
                          );
                        }}
                        className="custom-select"
                      >
                        <option value="">Select Category</option>

                        {categories
                          .filter((cat) => cat.status === "Active")
                          .map((cat) => (
                            <option key={cat.id} value={cat.categoryName}>
                              {cat.categoryName}
                            </option>
                          ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  {/* DATE

                  <Col xs={12} md={6}>
                    <Form.Group className="mb-3">

                      <Form.Label>Date</Form.Label>

                      <Form.Control
                        type="date"
                        value={date}
                        onChange={(e) =>
                          setDate(e.target.value)
                        }
                      />

                    </Form.Group>
                  </Col> */}
                  {/* BUTTON */}
                  <Col xs={12}>
                    {addUploadLoading ? (
                      <Spinner size="lg" />
                    ) : btnLabel === "Save" ? (
                      <Button
                        type="button"
                        variant="primary"
                        disabled={
                          addUploadLoading ||
                          !title.trim() ||
                          !description ||
                          !category ||
                          !keywords.trim() ||
                          !image ||
                          !!errorMessage
                        }
                        onClick={() => {
                          if (
                            !title.trim() ||
                            !description ||
                            !category ||
                            !keywords.trim() ||
                            !image ||
                            errorMessage
                          ) {
                            return;
                          }

                          setAddUploadLoading(true);
                          publishblog();
                        }}
                      >
                        Publish Blog
                      </Button>
                    ) : (
                      <Button
                        type="button"
                        variant="danger"
                        onClick={() => {
                          setAddUploadLoading(true);
                          updateBlog();
                        }}
                      >
                        Update Blog
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        )}

        {/* ================= BLOG TABLE ================= */}

        <Card className="shadow-sm border-0">
          <Card.Body>
            <h5 className="mb-3">All Blogs</h5>

            <div className="table-responsive">
              <Table bordered hover align="middle">
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Title</th>
                    <th>Slug</th>
                    <th>Description</th>
                    <th>Keywords</th>
                    <th>Category</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {blogs.map((blog) => (
                    <tr key={blog.id}>
                      {/* IMAGE */}

                      <td>
                        <img
                          onClick={() => {
                            window.location.href = `${baseUrlForFiles}/${blog.image}`;
                          }}
                          src={`${baseUrlForFiles}/${blog.image}`}
                          alt="blog"
                          width="60"
                          style={{ borderRadius: "8px" }}
                        />
                        {/* <Image
  src={`${baseUrlForFiles}/${blog.image}`}
  rounded
  width="70"
  height="50"
  style={{
    objectFit: "cover",
  }}
/> */}
                      </td>

                      {/* TITLE */}

                      <td>{blog.title}</td>

                      {/* SLUG */}

                      <td>{blog.slug}</td>

                      {/* DESCRIPTION */}

                      <td>
                        {blog.description.length > 50
                          ? blog.description.slice(0, 50) + "..."
                          : blog.description}
                      </td>

                      {/* KEYWORDS */}

                      <td>{blog.keywords}</td>

                      {/* CATEGORY */}

                      <td>{blog.category}</td>

                      {/* ACTIONS */}

                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <Button
                            size="sm"
                            variant="outline-primary"
                            className="btn-action btn-edit"
                            disabled={loadingEditId === blog.id}
                            onClick={() => {
                              console.log(blog.image);

                              setLoadingEditId(blog.id);

                              setIdToUpdateDeleteblog(blog.id);

                              setTitle(blog.title);
                              setSlug(blog.slug);
                              setCategory(blog.category);
                              setDescription(blog.description);
                              setKeywords(blog.keywords);
                              setOldImage(blog.image);
                              setImage(null);

                              setBtnLabel("Update");
                              setShowForm(true);

                              setTimeout(() => {
                                setLoadingEditId(null);
                              }, 500);
                            }}
                          >
                            {loadingEditId === blog.id ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              <FaEdit />
                            )}
                          </Button>

                          <Button
                            size="sm"
                            variant="outline-danger"
                            className="btn-action btn-delete"
                            disabled={loadingDeleteId === blog.id}
                            onClick={() => {
                              setLoadingDeleteId(blog.id);

                              deleteBlog(blog.id);

                              setTimeout(() => {
                                setLoadingDeleteId(null);
                              }, 500);
                            }}
                          >
                            {loadingDeleteId === blog.id ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              <FaTrash />
                            )}
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </AdminMasterLayout>
  );
};

export default BlogAdmin;
